module.exports = __webpack_public_path__ + "img/12_l_no.b71fde62.svg";